import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DemoMaterialModule } from '../demo-material-module';

import { RouterModule } from '@angular/router';
import { ChartistModule } from 'ng-chartist';
import { ChartsModule } from 'ng2-charts';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DeviceTypeRoutingModule } from './device-type-routing.module';

import { MatSelectModule } from '@angular/material/select';
import { DeviceTypesComponent } from './device-types/device-types.component';
import { AddDeviceTypeComponent } from './add-device-type/add-device-type.component';

@NgModule({
  declarations: [
    DeviceTypesComponent,
    AddDeviceTypeComponent
  ],
  imports: [
    CommonModule,
    DeviceTypeRoutingModule,
    DemoMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    NgxDatatableModule,
    FlexLayoutModule,
    RouterModule,
    ChartistModule,
    NgApexchartsModule,
    ChartsModule,
    MatSelectModule,
  ]
})
export class DeviceTypeModule {

}
